import React from 'react';
import RadioList from './RadioList';
import { FieldValues, Path } from 'react-hook-form';
import { translate } from '../../services/translate';

function CameraAlgorithmList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    return <RadioList items={['hasFacial', 'hasLpr', 'hasAreaInvasion'].map(algorithm => ({
        label: translate(algorithm),
        value: algorithm,
    }))} name={name} clearValue={null} />;
}

CameraAlgorithmList.getCount = RadioList.getCount;

export default CameraAlgorithmList;
